import React, { useState, useEffect } from 'react';
import HelpTogal from '../TogelButton/HelpTogal';
import CoupanServices from '../../services/CoupanServices.js';

function UpdateCoupan({ data, closeModal, onSuccess }) {

  const [formValues, setFormValues] = useState({
    name: '',
    description: '',
    upto: '',
    numberOfCoupons: '',
    endDate: '',
    price: '',
    maxDiscountAmount: '',
    termsAndConditions: '',
    totalnumberOfusagesCoupons: '',
    totalnumberOfusagesperuserCoupons: '',
  });


  useEffect(() => {
    if (data) {
      const formattedEndDate = data?.endDate
        ? new Date(data.endDate).toISOString().split('T')[0]
        : '';
  
      setFormValues({
        name: data?.name || '',
        description: data?.description || '',
        upto: data?.upto || '',
        numberOfCoupons: data?.numberOfCoupons || '',
        price: data?.price || '',
        endDate: formattedEndDate,
        maxDiscountAmount: data?.maxDiscountAmount || '',
        termsAndConditions: data?.termsAndConditions || '',
        totalnumberOfusagesCoupons: data?.totalnumberOfusagesCoupons || '',
        totalnumberOfusagesperuserCoupons: data?.totalnumberOfusagesperuserCoupons || '',
      });
    }
  }, [data]);
  

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };


  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      await CoupanServices.updateCoupon(data.id, formValues);
      alert('Addons updated successfully');
      onSuccess();
      closeModal();
    } catch (error) {
      console.error('Failed to update addons', error);
      alert('Failed to update addons');
    }
  };


  return (
    <div className="modal fade edit-box show d-block" id="editModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Addons Edit</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" onClick={closeModal} aria-label="Close" />
          </div>
          <div className="modal-body">
            <div className="container-box px-5">
              <div className="container-box-inner table-reponsive-tabe">
                <div className="page-details">
                  <form onSubmit={handleSubmit}>
                  <div className="row">
                                    <div className="col-lg-6 col-sm-12">
                                        <div className="input-field">
                                            <label>Coupon Code Name<span className="red">*</span></label>
                                            <input
                                                type="text"
                                                name="name"
                                                className="form-control"
                                                value={formValues.name}
                                                onChange={handleInputChange}
                                                placeholder="Enter name"
                                                required
                                            />
                                        </div>
                                    </div>


                                    <div className="col-lg-6 col-sm-6">
                                        <div className="input-field">
                                            <label>Discount Value (%)</label>
                                            <input
                                                type="number"
                                                name="upto"
                                                className="form-control"
                                                value={formValues.upto}
                                                onChange={handleInputChange}
                                                placeholder="5%"
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-6 col-sm-3">
                                        <div className="input-field">
                                            <label>Minimum Services Amount <span className="red">*</span></label>
                                            <input
                                                type="number"
                                                name="price"
                                                className="form-control"
                                                value={formValues.price}
                                                onChange={handleInputChange}
                                                placeholder="₹ 1500"
                                                required
                                                min="0"
                                                step="0"
                                            />
                                        </div>
                                    </div>


                                    <div className="col-lg-6 col-sm-6">
                                        <div className="input-field">
                                            <label>MAX Discount Amount</label>
                                            <input
                                                type="number"
                                                name="maxDiscountAmount"
                                                className="form-control"
                                                value={formValues.maxDiscountAmount}
                                                onChange={handleInputChange}
                                                placeholder="300"
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-6 col-sm-6">
                                        <div className="input-field">
                                            <label>Expire Date<span className="red">*</span></label>
                                            <input
                                                type="date"
                                                name="endDate"
                                                className="form-control"
                                                value={formValues.endDate}
                                                onChange={handleInputChange}
                                                required
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-6 col-sm-6">
                                        <div className="input-field">
                                            <label>Total Number of Usage Limit </label>
                                            <input
                                                type="number"
                                                name="totalnumberOfusagesCoupons"
                                                className="form-control"
                                                value={formValues.totalnumberOfusagesCoupons}
                                                onChange={handleInputChange}
                                                placeholder="10"
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-6 col-sm-6">
                                        <div className="input-field">
                                            <label>Total Number of usage per user</label>
                                            <input
                                                type="number"
                                                name="totalnumberOfusagesperuserCoupons"
                                                className="form-control"
                                                value={formValues.totalnumberOfusagesperuserCoupons}
                                                onChange={handleInputChange}
                                                placeholder="2"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-12 col-sm-12">
                                        <div className="input-field">
                                            <label>Terms And Conditions</label>
                                            <textarea
                                                className="form-control video-desc h-auto"
                                                name="termsAndConditions"
                                                value={formValues.termsAndConditions}
                                                onChange={handleInputChange}
                                                placeholder="Enter Terms And Conditions"
                                                required
                                            />
                                        </div>
                                    </div>
                                </div>
                    <button className="submit-green-btn">Submit</button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UpdateCoupan;
